import { useEffect, useState } from "react";
import { API_URL as API } from "../config";

const cache = {};

export function usePageContent(page) {
  const [content, setContent] = useState(cache[page] || {});
  const [loaded, setLoaded] = useState(!!cache[page]);

  useEffect(() => {
    if (cache[page]) {
      setContent(cache[page]);
      setLoaded(true);
      return;
    }
    fetch(`${API}/api/content/${page}`)
      .then(r => r.ok ? r.json() : { content: {} })
      .then(data => {
        const c = data.content || {};
        cache[page] = c;
        setContent(c);
        setLoaded(true);
      })
      .catch(() => setLoaded(true));
  }, [page]);

  // Helper: get CMS value or fallback
  const get = (key, fallback) => content[key] || fallback;

  return { content, loaded, get };
}
